import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { UseFormReturn } from "react-hook-form";
import { StudentFormValues } from "../schema/studentSchema";
import { useIsMobile } from "@/hooks/use-mobile";
import { useTranslations } from "@/hooks/useTranslations";
import { Switch } from "@/components/ui/switch";
import { useParams } from "react-router-dom";
import { useEffect } from "react";

interface PersonalDataTabProps {
  form: UseFormReturn<StudentFormValues>;
}

export const PersonalDataTab = ({ form }: PersonalDataTabProps) => {
  const isMobile = useIsMobile();
  const { t } = useTranslations("students");
  const { id } = useParams(); // Para verificar se estamos editando ou criando
  const isEditMode = !!id;
  
  useEffect(() => {
    const hasScheduleAccess = form.getValues("has_schedule_access");
    console.log("Current has_schedule_access value:", hasScheduleAccess);
  }, [form]);
  
  return (
    <div className="space-y-6">
      <div className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-2'} gap-6`}>
        <FormField
          control={form.control}
          name="first_name"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="dark:text-gray-200">{t("form.firstName")}</FormLabel>
              <FormControl>
                <Input placeholder={t("form.firstName")} {...field} className="dark:bg-gray-700 dark:text-white dark:border-gray-600 dark:placeholder:text-gray-400" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="last_name"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="dark:text-gray-200">{t("form.lastName")}</FormLabel>
              <FormControl>
                <Input placeholder={t("form.lastName")} {...field} className="dark:bg-gray-700 dark:text-white dark:border-gray-600 dark:placeholder:text-gray-400" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      
      <div className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-2'} gap-6`}>
        <FormField
          control={form.control}
          name="email"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="dark:text-gray-200">{t("form.email")}</FormLabel>
              <FormControl>
                <Input type="email" placeholder={t("form.email")} {...field} className="dark:bg-gray-700 dark:text-white dark:border-gray-600 dark:placeholder:text-gray-400" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="phone"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="dark:text-gray-200">{t("form.phone")}</FormLabel>
              <FormControl>
                <Input placeholder={t("form.phone")} {...field} className="dark:bg-gray-700 dark:text-white dark:border-gray-600 dark:placeholder:text-gray-400" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      
      <div className={`grid ${isMobile ? 'grid-cols-1' : 'grid-cols-2'} gap-6`}>
        <FormField
          control={form.control}
          name="birth_date"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="dark:text-gray-200">{t("form.birthDate")}</FormLabel>
              <FormControl>
                <Input type="date" className="p-2 dark:bg-gray-700 dark:text-white dark:border-gray-600" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        
        <FormField
          control={form.control}
          name="emergency_contact"
          render={({ field }) => (
            <FormItem>
              <FormLabel className="dark:text-gray-200">{t("form.emergencyContact")}</FormLabel>
              <FormControl>
                <Input placeholder={t("form.emergencyContact")} {...field} className="dark:bg-gray-700 dark:text-white dark:border-gray-600 dark:placeholder:text-gray-400" />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </div>
      
      <div className="mt-6 p-4 border border-gray-200 dark:border-gray-700 rounded-lg bg-gray-50 dark:bg-gray-800/50">
        <div className="space-y-4">
          <FormField
            control={form.control}
            name="has_schedule_access"
            render={({ field }) => (
              <FormItem className="flex flex-row items-center justify-between rounded-lg">
                <div className="space-y-0.5">
                  <FormLabel className="text-base dark:text-gray-200">
                    {t("form.scheduleAccess")}
                  </FormLabel>
                </div>
                <FormControl>
                  <Switch
                    checked={field.value}
                    onCheckedChange={field.onChange}
                    className="data-[state=checked]:bg-flame"
                  />
                </FormControl>
              </FormItem>
            )}
          />
          
          {!isEditMode && (
            <FormField
              control={form.control}
              name="send_account_email"
              render={({ field }) => (
                <div className="space-y-2">
                  <FormItem className="flex flex-row items-center justify-between rounded-lg">
                    <div className="space-y-0.5">
                      <FormLabel className="text-base dark:text-gray-200">
                        {t("form.sendAccountEmail")}
                      </FormLabel>
                    </div>
                    <FormControl>
                      <Switch
                        checked={field.value}
                        onCheckedChange={field.onChange}
                        className="data-[state=checked]:bg-flame"
                      />
                    </FormControl>
                  </FormItem>
                  <p className="text-sm text-muted-foreground dark:text-gray-400 mt-2">
                    {field.value 
                      ? "Será enviado um email automático para criação de conta no TrainerFOLIO" 
                      : t("form.askStudentToCreate")
                    }
                  </p>
                </div>
              )}
            />
          )}
        </div>
      </div>
    </div>
  );
};
